module.exports = __webpack_public_path__ + "static/media/schoolHoop.856a4f71.png";